import Vue from "vue";
import { appClass } from "./modules/appClass.js";
Vue.config.silent = true;
Vue.config.productionTip = false;

Vue.prototype.$PROVIDER_SETUP_CONFIG = window.PROVIDER_SETUP_CONFIG;

Vue.directive('lazy', {
  inserted: (el, binding) => {
    function loadImage() {
      el.src = binding.value;
    }

    function handleIntersect(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadImage();
          observer.unobserve(el);
        }
      });
    }

    const observer = new IntersectionObserver(handleIntersect);
    observer.observe(el);
  }
});
new appClass();
